module.exports = require('./helpers/bundle-url').getBundleURL('2lNV8') + "warning.685317d0.svg";